import { useEffect, useState } from "react"
import Cookies from "js-cookie"

import SEO from "../components/seo"
import Button from "../components/buttons/Button"
import FullscreenWrapper from "../components/FullscreenWrapper"
import SectionHeader from "../components/SectionHeader"

import * as styles from "../styles/order-completed.module.css"
import PageSubTitle from "../components/PageSubTitle"
import useTranslations from "../hooks/useTranslations"

const OrderCompleted = () => {
  // const [partner, setPartner] = useState(false)

  const {
    pageOrderCompletedTitle,
    pageOrderCompletedHeader,
    // pageOrderCompletedPartner,
    pageOrderCompletedSubHeader,
    pageOrderCompletedDescription,
    pageOrderCompletedButton,
  } = useTranslations()

  // useEffect(() => {
  //   const partnerCookie = Cookies.get("partner")
  //   if (partnerCookie) {
  //     setPartner(partnerCookie)
  //   }
  // }, [])

  return (
    <>
      <SEO title={pageOrderCompletedTitle} />
      <FullscreenWrapper>
        <div className={styles.Container}>
          <div>
            <SectionHeader>
              {pageOrderCompletedHeader}!
              {/* {partner
                ? `,\n${partner.toUpperCase()}${pageOrderCompletedPartner}!`
                : "!"} */}
            </SectionHeader>
            <PageSubTitle>{pageOrderCompletedSubHeader}</PageSubTitle>
            <div>{pageOrderCompletedDescription}</div>
          </div>
          <Button bgStyle="primary" label={pageOrderCompletedButton} link="/" />
        </div>
      </FullscreenWrapper>
    </>
  )
}

export default OrderCompleted
